import { useEffect } from 'react'

import { useDataLayer } from '~/hooks/useDataLayer/useDataLayer'
import { useGetMe } from '~/pages/hooks/useGetMe'

export function useTrackUserAttribute(): void {
  const { push } = useDataLayer()
  const { organizationId, memberId, organizationName } = useGetMe()

  if (
    organizationId === undefined ||
    memberId === undefined ||
    organizationName === undefined
  ) {
    return
  }

  useEffect(() => {
    push('identify', {
      memberId,
    })
    push('attribute', {
      organizationId,
      organizationName,
    })
  }, [organizationId, memberId, organizationName, push])
}
